import Header from '../../components/Layout/Header';
import SidebarMenu from '../../components/Layout/SidebarMenu';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminLayout({ setStep, showSidebar = true }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="flex justify-center items-center w-full max-w-screen h-screen min-h-screen">
      {showSidebar && <SidebarMenu setStep={setStep} step={0} useSteps={false} menuItems={[
        { label: 'Competitions', link: '/admin/competitions' },
        { label: 'Search By Rep', link: '/admin/rep_teams' },
        { label: 'Rep Portal', link: '/login' },
        { label: 'Sync Rep Data', link: '/admin/sync_rep_data' },
      ]} />}
      <div className="flex flex-col justify-center items-center w-full h-full max-h-min">
        <Header adminPortal={true} logout={handleLogout} user={user} />
        <Outlet />
      </div>
    </div>
  );
}
